/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ProfessionalStatus = {
  type: 'Enum',
} as const;
